<ion-row class="p0">
<ion-col class="content-padding" size-xl="6" size-lg="6" size-md="6" size-sm="6" size-xs="6">
    <div class = "jobPosition">
      <div class = "static-select-width" [ngClass]="{'alter-padding': !isMultiPatientAllowed}">
        <select [disabled]="!availablePatients.length"   [compareWith]="comparePatients"
  [(ngModel)]="selectedPatient" class="position select-font" (change)="handlePatientIdChange()">
          <option class = "options" [ngValue]="patient" *ngFor="let patient of availablePatients; trackBy:trackByPatient">
            {{patient.id}}
          </option>
        </select>
        <i class = "fa fa-chevron-down"></i>
      </div>
    </div>
  </ion-col>
  <ion-col class="content-padding" [ngClass] = "{'align-column': currentView === 'broadcast-request'}" size-xl="6" size-lg="6" size-md="6" size-sm="6" size-xs="6">
    <div class = "jobPosition">
      <div class = "full-col-width">
        <app-places-autocomplete [ngClass]="{'create-shift': currentView === 'create-shift', 'broadcast-request': currentView === 'broadcast-request'}" [formatedAddress]="selectedPatient?.address?.street" class="style-broadcast" [currentView] = "currentView" [isMultiPatientAllowed] =  "true" (addressChanged)="handleAddressChange($event)"></app-places-autocomplete>
      </div>
    </div>
  </ion-col>
</ion-row>